module.exports = __webpack_public_path__ + "static/img/travelServicesBg.c8fec4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/travelServicesBg.png
// module id = WmtE
// module chunks = 1